import { LorenMeteringType } from "../../../../features/loren-assets/interfaces/loren-metering-type";

export const LorenMetricUnits = new Map([
  [LorenMeteringType.BAROMETRIC_PRESSURE_SENSOR, "hPa"],
  [LorenMeteringType.CO2_SENSOR, "ppm"],
  [LorenMeteringType.CURRENT_SENSOR, "A"],
  [LorenMeteringType.DISTANCE_SENSOR, "m"],
  [LorenMeteringType.EXTERNAL_CURRENT_SENSOR, "A"],
  [LorenMeteringType.EXTERNAL_VOLTAGE_SENSOR, "V"],
  [LorenMeteringType.FILL_LEVEL_SENSOR, ""],
  [LorenMeteringType.FLUID_FLOW_SENSOR, "L"],
  [LorenMeteringType.HCHO_SENSOR, "mg/m<sup>3</sup>"],
  [LorenMeteringType.HUMIDITY_SENSOR, "%"],
  [LorenMeteringType.ILLUMINATION_SENSOR, "Lux"],
  [LorenMeteringType.LIGHT_SENSOR, ""],
  [LorenMeteringType.OZONE_SENSOR, "ppm"],
  [LorenMeteringType.PM10_SENSOR, "μg/m<sup>3</sup>"],
  [LorenMeteringType.PM2_5_SENSOR, "μg/m<sup>3</sup>"],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR, "GWC"],
  [LorenMeteringType.SOIL_TEMPERATURE_SENSOR, "° C"],
  [LorenMeteringType.TEMPERATURE_SENSOR, "° C"],
  [LorenMeteringType.TVOC_SENSOR, ""],
  [LorenMeteringType.VOLTAGE_SENSOR, "V"],
  [LorenMeteringType.ARCING_SENSOR, "%"],
  [LorenMeteringType.NTL_SENSOR, "%"],
  [LorenMeteringType.SOIL_MOISTURE_SENSOR_VWC, " VWC"],
  [LorenMeteringType.ELECTRICAL_CONDUCTIVITY_SENSOR, " µs/cm"],
]);
